import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {SkjermingDetaljerModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MedlemListevisningKompaktKomponent} from "../../../medlem/komponenter/medlem-listevisning-kompakt/medlem-listevisning-kompakt";
import {TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {TranslateModule} from "@ngx-translate/core";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";
import {skjermedeMedlemmerMedArvInfo} from "felles-ng2/modell/skjermingModellHjelpere";
import {EnumOversettelser} from "felles-ng2/tjenester/i18n/EnumOversettelser";
import {SkjermetEntitetType} from "felles-ng2/tjenester/datalager/SkjermingDatatjeneste";
import {SkjermingBeskrivelseKomponent} from "../skjerming-beskrivelse/skjerming-beskrivelse";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";

const debug = initDebugger('SkjermingVisKomponent');

/**
 * Viser hvem som er skjermet (ikke har tilgang)
 */
@Component({
    selector: 'skjerming-vis',
    templateUrl: 'skjerming-vis.html',
    styleUrl: 'skjerming-vis.scss',
    imports: [
        MedlemListevisningKompaktKomponent,
        TittelVerdiKomponent,
        TranslateModule,
        VerdiKomponent,
        SkjermingBeskrivelseKomponent,
        HtmlFormatertKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkjermingVisKomponent {

    skjerming = input.required<SkjermingDetaljerModell>();
    type = input.required<SkjermetEntitetType>();

    /** Årsak/kommentar vises kun dersom {@link SkjermingDetaljerModell#aarsak} er ikke-tom */
    visAarsak = computed(() => erIkkeTomStreng(this.skjerming().aarsak));
    /** Liste med medlemmer som har skjermet tilgang, samt informasjon om skjermingen er arvet eller ei */
    skjermedeMedlemmer = computed(() => skjermedeMedlemmerMedArvInfo(this.skjerming()));
    typenavn = computed(() => this.enumOversettelser.oversettSkjermetEntitetType(this.type()));
    typer = SkjermetEntitetType;

    constructor(private enumOversettelser: EnumOversettelser) {
    }
}
